import { Subject } from 'rxjs';

import { Component, Inject, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { SnAlarm } from '@lib/api/entities';
import { GoogleMapPopup, GOOGLE_MAP_POPUP_DATA } from '@lib/geo/google/map';
import { AlprDetectionService } from '@lib/vehicle-intelligence';

import { AlarmSendDialogComponent } from '../alarm-send-dialog';

@Component({
  selector: 'fs-alarm-details-popup',
  templateUrl: './alarm-details-popup.component.html',
  styleUrls: ['./alarm-details-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlarmDetailsPopupComponent implements OnDestroy {
  public orgRadius: number;
  public length: number;
  public openPopups: GoogleMapPopup[] = [];
  private _destroy$ = new Subject<void>();

  constructor(
    @Inject(GOOGLE_MAP_POPUP_DATA)
    public readonly data: {
      alarm: SnAlarm;
      hideActions: boolean;
    },
    private readonly _alprDetectionService: AlprDetectionService,
    private readonly _matDialog: MatDialog,
  ) {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public isAlprAlarm(): boolean {
    return this._alprDetectionService.isAlprAlarm(this.data.alarm);
  }

  public openSendDialog(alarm: SnAlarm): void {
    const dialogRef = this._matDialog.open(AlarmSendDialogComponent, { data: alarm });

    dialogRef.afterClosed().subscribe((result) => {
      return result;
    });
  }
}
